import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "flex items-center justify-between gap-2 text-xs text-neutral50" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "m-0 text-sm font-bold text-textPrimary" }
const _hoisted_5 = { class: "m-0 text-xs text-neutral50" }
const _hoisted_6 = { class: "flex flex-wrap items-center gap-1" }
const _hoisted_7 = ["data-testid"]

import { computed } from 'vue'

import StatusBadge from '@/components/designSystem/Badges/StatusBadge.vue'
import { CONTAINER_KIND_LABELS, ContainerKind } from '@/constants/ds-attendance.constants'
import type { DSAttendanceContainer } from '@/types/ds-attendance.types'

import { formatReferenceDay, shiftNames } from '../../utils/queue-table-columns'
import DsAttendanceSlaLine from './DsAttendanceSlaLine.vue'

/** Cartão compacto do Kanban (mockups K1/K2). Sem arrastar (Q4): muda de coluna na recarga. */

export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceKanbanCard',
  props: {
    container: {},
    nowMs: {}
  },
  emits: ["details"],
  setup(__props: any, { emit }) {

const props = __props;




const kindLabel = computed(() =>
  props.container.kind === ContainerKind.ATIVIDADE
    ? CONTAINER_KIND_LABELS[ContainerKind.ATIVIDADE]
    : CONTAINER_KIND_LABELS[ContainerKind.FOLHA]
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: "flex flex-col gap-1.5 rounded-md border border-lightGray30 bg-white p-2.5 text-left",
    "data-testid": `ds-attendance-kanban-card-${_ctx.container.id}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "#" + _toDisplayString(_ctx.container.id) + " · " + _toDisplayString(kindLabel.value), 1),
      _createElementVNode("span", null, "Plantão " + _toDisplayString(_unref(formatReferenceDay)(_ctx.container.referenceDate)), 1)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.container.schedule?.name ?? 'Escala não informada'), 1),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.container.healthUnit?.name ?? 'Unidade não informada') + " · " + _toDisplayString(_unref(shiftNames)(_ctx.container)), 1),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(StatusBadge, {
        status: _ctx.container.status
      }, null, 8, ["status"])
    ]),
    _createVNode(DsAttendanceSlaLine, {
      container: _ctx.container,
      "now-ms": _ctx.nowMs
    }, null, 8, ["container", "now-ms"]),
    _createElementVNode("button", {
      type: "button",
      class: "self-end text-xs font-medium text-primary underline",
      "data-testid": `ds-attendance-kanban-card-${_ctx.container.id}-details`,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('details', _ctx.container.id)))
    }, " Ver detalhes ", 8, _hoisted_7)
  ], 8, _hoisted_1))
}
}

})